import React from "react";
import Img from "./basic/Img";

function Live() {
    return (
        <div className="live">
            <div className="live-green-wrap">
                <Img fileName={"liveGreen"} className="live-green" />
            </div>
            <div className="live-pink-wrap">
                <Img fileName={"livePink"} className="live-pink" />
            </div>
            <div className="live-yellow-wrap">
                <Img fileName={"liveYellow"} className="live-yellow" />
            </div>
        </div>
    );
}

export default Live;
